import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  Switch,
  TouchableOpacity,
} from "react-native";
import React, { useState } from "react";
import ExperienceFilter from "./advanceFilterComponents/ExperienceFilter";
// import { Switch } from 'react-native-switch';
import GlobalStyles from "../../../../globalStyles/globalStyles";
import HeightFilter from "./advanceFilterComponents/HeightFilter";
import OptionsFilter from "../filterComponents/OptionsFilter";
import LocationFilter from "./advanceFilterComponents/LocationFilter";
import { Colors } from "../../../../globalStyles/ColorConfig";
import { styles } from "./advanceFilterStyles";
import FilterItemAdvance from "./advanceFilterComponents/FilterItemAdvance";
import { toggleModal } from "../../../../screens/HomeFeed/helpers/feedHelpers";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface AdvanceFiltersProps {
  onPress: (
    label: string,
    value: string,
    filters: any,
    setFilters: any,
    component?: any,
    name?: any
  ) => void;
  filters: any;
  setFilters: any;
  toggleModal: () => void;
}

export default function AdvanceFilters({
  onPress,
  filters,
  setFilters,
  toggleModal,
}: AdvanceFiltersProps) {
  const [isEnabled, setIsEnabled] = useState(filters.advanceFilters.isVerified);
  const [active, setActive] = useState(false);

  const advanceFiltersData = [
    {
      label: "Verified profiles only",
      switch: true,
      value: "",
      name: "isVerified",
      advanced: true,
    },
    {
      label: "Experience they're interested in",
      advanced: true,
      value: `${filters?.advanceFilters?.experienceInterestedIn.length} selected`,
      component: <ExperienceFilter filters={filters} setFilters={setFilters} />,
      name: "experienceInterestedIn",
    },
    // {
    //   label: "Height",
    //   value: "5’ 5” - 6’ 0”",
    //   name: "heightRange",
    //   component: <HeightFilter filters={filters} setFilters={setFilters} />,
    // },
    {
      label: "Body type",
      value: filters?.advanceFilters?.bodyType
        ? filters?.advanceFilters?.bodyType &&
          filters?.advanceFilters?.bodyType.length > 1
          ? filters?.advanceFilters?.bodyType?.join(", ")
          : filters?.advanceFilters?.bodyType
        : "Select",
      type: "optionFilter",
      advanced: true,
      multiselect: true,
      name: "bodyType",
      options: [
        {
          label: "Slim",
          active: false,
        },
        {
          label: "Muscular",
          active: false,
        },
        {
          label: "Athletic",
          active: false,
        },
        {
          label: "Average",
          active: false,
        },
        {
          label: "Curvy",
          active: false,
        },
        {
          label: "Petite",
          active: false,
        },
        {
          label: "Bodybuilder",
          active: false,
        },
        {
          label: "Thin",
          active: false,
        },
        {
          label: "Full-Figured",
          active: false,
        },
        {
          label: "Other",
          active: false,
        },
      ],
    },
    // {
    //   label: "Location",
    //   name: "location",
    //   value: "Bangkok, Thailand",
    //   component: <LocationFilter filters={filters} setFilters={setFilters} />,
    // },
    {
      label: "Ethnicity",
      name: "ethnicity",
      advanced: true,
      multiselect: true,
      value: filters?.advanceFilters?.ethnicity
        ? filters?.advanceFilters?.ethnicity &&
          filters?.advanceFilters?.ethnicity.length > 1
          ? filters?.advanceFilters?.ethnicity?.join(", ")
          : filters?.advanceFilters?.ethnicity
        : "Select",
      type: "optionFilter",

      options: [
        { label: "Asian", active: false },
        { label: "African-American", active: false },
        { label: "Hispanic/Latino", active: false },
        { label: "White", active: false },
        { label: "Native-American/Alaska-Native", active: false },
        { label: "Middle-Eastern", active: false },
        { label: "Pacific-Islander", active: false },
        { label: "Other", active: false },
      ],
    },
    // {
    //   label: "Children",
    //   name: "children",
    //   value: "Don’t want children",
    //   type: "optionFilter",
    //   options: [
    //     {
    //       label: "Yes",
    //       active: false,
    //     },
    //     {
    //       label: "Maybe",
    //       active: false,
    //     },
    //     {
    //       label: "No",
    //       active: false,
    //     },
    //   ],
    // },
    {
      label: "Education level",
      advanced: true,
      value: filters?.advanceFilters?.educationLevel
        ? filters?.advanceFilters?.educationLevel &&
          filters?.advanceFilters?.educationLevel.length > 1
          ? filters?.advanceFilters?.educationLevel?.join(", ")
          : filters?.advanceFilters?.educationLevel
        : "Select",
      name: "educationLevel",
      type: "optionFilter",
      multiselect: true,
      options: [
        {
          label: "high-school",
          active: false,
        },
        {
          label: "bachelor's",
          active: false,
        },
        {
          label: "master's",
          active: false,
        },
        {
          label: "phd",
          active: false,
        },
      ],
    },
    {
      label: "Seeking in",
      multiselect: true,
      advanced: true,
      value: filters?.advanceFilters?.seeking
        ? filters?.advanceFilters?.seeking &&
          filters?.advanceFilters?.seeking.length > 1
          ? filters?.advanceFilters?.seeking?.join(", ")
          : filters?.advanceFilters?.seeking
        : "Select",
      name: "seeking",
      type: "optionFilter",
      options: [
        {
          label: "Casual",
          active: false,
        },
        {
          label: "Serious",
          active: false,
        },
        {
          label: "Friendship",
          active: false,
        },
        {
          label: "Open to all",
          active: false,
        },
        {
          label: "Online",
          active: false,
        },
      ],
    },
    {
      label: "Relationship status",
      advanced: true,
      value: filters?.advanceFilters?.relationshipStatus
        ? filters?.advanceFilters?.relationshipStatus &&
          filters?.advanceFilters?.relationshipStatus.length > 1
          ? filters?.advanceFilters?.relationshipStatus?.join(", ")
          : filters?.advanceFilters?.relationshipStatus
        : "Select",
      type: "optionFilter",
      multiselect: true,
      name: "relationshipStatus",
      options: [
        {
          label: "Single",
          active: false,
        },
        {
          label: "Relationship",
          active: false,
        },
        {
          label: "Married",
          active: false,
        },
        {
          label: "Divorced",
          active: false,
        },
        {
          label: "Deserted",
          active: false,
        },
      ],
    },
    // {
    //   label: "Smoking",
    //   value: "No",
    //   type: "optionFilter",
    //   name: "smoker",
    //   options: [
    //     {
    //       label: "Yes",
    //       active: false,
    //     },
    //     {
    //       label: "Sometimes",
    //       active: false,
    //     },
    //     {
    //       label: "No",
    //       active: false,
    //     },
    //   ],
    // },
    // {
    //   label: "Drinking",
    //   value: "No",
    //   name: "drinker",
    //   type: "optionFilter",
    //   options: [
    //     {
    //       label: "Yes",
    //       active: false,
    //     },
    //     {
    //       label: "Sometimes",
    //       active: false,
    //     },
    //     {
    //       label: "No",
    //       active: false,
    //     },
    //   ],
    // },
  ];

  const handlePress = (
    label: string,
    value: string,
    component: any,
    name: any,
    filters: any,
    setFilters: any
  ) => {
    onPress(
      label,
      value,
      React.cloneElement(component, { filters, setFilters }),
      name,
      filters,
      setFilters
    );
  };

  const handleApplyFilters = () => {
    setFilters((prevFilters: any) => {
      const updatedFilters = {
        ...prevFilters,
        appliedFilters: {
          ...prevFilters.appliedFilters,
          basicFilters: { ...prevFilters.basicFilters },
        },
      };

      // Save the updated state to AsyncStorage
      AsyncStorage.setItem("filters", JSON.stringify(filters));

      return updatedFilters;
    });

    toggleModal();
  };
  return (
    <View
      style={{
        position: "relative",
        height: "100%",
      }}
    >
      <ScrollView
        style={{
          marginBottom: 100,
        }}
      >
        {advanceFiltersData.map((filter, index) => (
          <FilterItemAdvance
            key={index}
            multiselect={filter.multiselect}
            filter={filter}
            label={filter.label}
            value={filter.value}
            switch={filter.switch || false}
            type={filter.type}
            component={filter.component}
            name={filter.name}
            filters={filters}
            setFilters={setFilters}
            handlePress={handlePress}
            isEnabled={isEnabled}
            setIsEnabled={setIsEnabled}
            advanced={true}
          />
        ))}
      </ScrollView>
      <View
        style={{
          paddingHorizontal: 16,
          position: "absolute",
          width: "100%",
          zIndex: 1,
          bottom: 20,
        }}
      >
        <TouchableOpacity
          style={[
            GlobalStyles.primaryButton,
            {
              backgroundColor: Colors.darkGreen,
              width: "100%",
              marginHorizontal: "auto",
            },
          ]}
          onPress={handleApplyFilters}
        >
          <Text
            style={[
              GlobalStyles.ctaText,
              {
                color: "#FDFBF9",
              },
            ]}
          >
            Apply Filters
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}
